import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Input } from "antd";
import { useDebouncedCallback } from "use-debounce";
import { RootState } from "store/Reducers";
import { handleSetUserMessageFilter } from "../../ClientSideStates";
import { SearchOutlined } from "@ant-design/icons";


const Search = () => {
  const { userFilter:filter } = useSelector((state: RootState) => state.message);
  let dispatch = useDispatch();
  const debounce = useDebouncedCallback((inputValue) => {
    let value = inputValue?.trim();
    if (value) {
      let newFilter = { ...filter };
      newFilter["SearchKey"] = value;
      newFilter["PageSize"] = -1;
      dispatch(handleSetUserMessageFilter({ filter: newFilter }));
    } else {
      let newFilter = { ...filter };
      delete newFilter["SearchKey"];
      newFilter["PageSize"]=20
      dispatch(handleSetUserMessageFilter({ filter: newFilter }));
    }
  }, 1000);
  let [searchValue, setSearchValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (filter) {
      setSearchValue(filter[`SearchKey`]);
    }
  }, [filter]);

  return (
    <>
      <div className="!flex  items-center !w-full bg-white !rounded-md  !shadow-sm ">
        <Input
          allowClear
       
          prefix={<SearchOutlined className=" !ml-2 !mr-4 !text-black" />}
          className="!py-2 !border-0 !w-full !bg-[#ffff] !text-black !rounded-md"
          placeholder={"Ara..."}
          onChange={(e) => {
            setSearchValue(e.target.value);
            debounce(e.target.value);
          }}
          value={searchValue}
        />
    
      </div>
    </>
  );
};

export default Search;
